import React, { useState, useEffect, useRef } from "react";
import { Form, Input, Button, message, Space, Checkbox } from "antd";
import { Link } from "react-router-dom";
import axiosInstance from "../../axios/axiosInstance";
import { useLocation } from "react-router-dom";
import "./login.scss";
import Logon from "./logon";
const Login = () => {
  const [form] = Form.useForm();
  const location = useLocation();
  // 解析URL参数
  const searchParams = new URLSearchParams(location.search);
  const mode = searchParams.get("mode");
  const [type, setType] = useState(mode === "register" ? 2 : 1);
  const [logonType, setLogonType] = useState(2);
  const [sendButtonDisabled, setSendButtonDisabled] = useState(false);
  const [timer, setTimer] = useState(null);
  const [countdown, setCountdown] = useState(0);
  const [error, setError] = useState(null);
  const [captcha, setCaptcha] = useState("");
  const [captchaImage, setCaptchaImage] = useState("");
  const canvasRef = useRef(null);
  const [agreeToTerms, setAgreeToTerms] = useState(false);
  const [agreeToPrivacy, setAgreeToPrivacy] = useState(false);
  // 生成随机验证码
  const generateCaptcha = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const chars =
      "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    let captchaText = "";

    // 清空画布
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // 设置渐变背景
    const gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
    gradient.addColorStop(0, "#f0f2f5");
    gradient.addColorStop(1, "#e6f4ff");
    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    // 生成4位验证码
    for (let i = 0; i < 4; i++) {
      const char = chars[Math.floor(Math.random() * chars.length)];
      captchaText += char;

      // 随机字体大小和颜色
      const fontSize = 28 + Math.random() * 8;
      ctx.font = `bold ${fontSize}px Arial`;
      ctx.fillStyle = `rgb(${Math.random() * 60}, ${Math.random() * 60}, ${
        Math.random() * 60
      })`;
      ctx.textBaseline = "middle";
      ctx.textAlign = "center";

      const x = 30 + i * 40;
      const y = canvas.height / 2;
      const rotation = (Math.random() - 0.5) * 0.3;

      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(rotation);
      ctx.fillText(char, 0, 0);
      ctx.restore();
    }

    // 添加干扰线
    for (let i = 0; i < 4; i++) {
      ctx.beginPath();
      ctx.strokeStyle = `rgba(${Math.random() * 255}, ${Math.random() * 255}, ${
        Math.random() * 255
      }, 0.2)`;
      ctx.lineWidth = 1;
      ctx.moveTo(Math.random() * canvas.width, Math.random() * canvas.height);
      ctx.lineTo(Math.random() * canvas.width, Math.random() * canvas.height);
      ctx.stroke();
    }

    // 添加干扰点
    for (let i = 0; i < 30; i++) {
      ctx.beginPath();
      ctx.fillStyle = `rgba(${Math.random() * 255}, ${Math.random() * 255}, ${
        Math.random() * 255
      }, 0.2)`;
      ctx.arc(
        Math.random() * canvas.width,
        Math.random() * canvas.height,
        1,
        0,
        2 * Math.PI
      );
      ctx.fill();
    }

    setCaptcha(captchaText);
  };

  // 组件加载时生成验证码
  useEffect(() => {
    if (type === 2 && canvasRef.current) {
      generateCaptcha();
    }
  }, [type]);

  useEffect(() => {
    form.resetFields();
  }, [form, type]);
  const handleSubmit = (values) => {
    if (!agreeToTerms) {
      message.warning("请阅读并同意用户协议和隐私政策");
      return;
    }
    // 表单提交逻辑，如登录验证等
    console.log("Received values of form: ", values);
    let param = {
      ...values,
    };
    delete param.confirmPassword;
    axiosInstance
      .post(`/account/register`, param)
      .then((response) => {
        if (response.data.code == "10000") {
          message.success("注册成功，请登录");
          sessionStorage.setItem("token", response.data.data.token);
          setType(2);
        } else {
          message.error(response.data.msg);
        }
      })
      .catch((error) => {
        // setError(error);
      });
  };
  const handleGetCode = async () => {
    // 验证手机号是否正确
    try {
      const values = await form.validateFields(["phone", "imageCaptcha"]);
      if (values.imageCaptcha.toLowerCase() !== captcha.toLowerCase()) {
        message.error("图形验证码错误");
        generateCaptcha();
        return;
      }
      await form.validateFields(["phone"]);
      const phone = form.getFieldValue("phone"); // 获取手机号
      setSendButtonDisabled(true); // 禁用按钮开始倒计时
      setCountdown(60);
      axiosInstance
        .get(`/account/sendVerifyCode?phone=${phone}`)
        .then((response) => {
          if (response.data.code == "10000") {
          } else {
            message.error(response.data.msg);
          }
        })
        .catch((error) => {
          setError(error);
        });
      // 这里可以调用后端API发送验证码
      // 使用setInterval实现倒计时
      const interval = setInterval(() => {
        setCountdown((prevCountdown) => {
          if (prevCountdown > 0) {
            return prevCountdown - 1;
          } else {
            clearInterval(interval);
            setSendButtonDisabled(false); // 倒计时结束，启用按钮
            return 0;
          }
        });
      }, 1000);
    } catch (error) {
      console.error("手机号验证失败", error);
    }
  };
  useEffect(() => {
    return () => {
      if (timer) {
        clearInterval(timer);
      }
    };
  }, [timer]);

  const handleOpenLink = (link) => {
    window.open(link, "_blank");
  };
  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 14 },
    },
  };
  const changeLogin = () => {
    setType((prevType) => (prevType === 1 ? 2 : 1));
    setLogonType(1);
  };
  const changeLogon_type = () => {
    setLogonType((prevType) => (prevType === 1 ? 2 : 1));
  };
  const passwordRules = [
    { required: true, message: "请输入密码" },
    ({ getFieldValue }) => ({
      validator(_, value) {
        if (!value || typeof value !== "string") {
          return Promise.resolve();
        }
        if (value.length < 6 || value.length > 16) {
          return Promise.reject("密码长度应为6-16位");
        }
        if (/[\u4e00-\u9fa5]/.test(value)) {
          return Promise.reject("密码不能包含中文");
        }
        return Promise.resolve();
      },
    }),
  ];
  return (
    <div className="login_div">
      <div className="login-cont">
        <img src={require("./img/login.png")} alt="" />
        <div className="form">
          <span onClick={changeLogin}>
            {type == 1 ? (
              <img src={require("./img/dl_logo.png")} alt="" />
            ) : (
              <img src={require("./img/login_logo.png")} alt="" />
            )}{" "}
          </span>

          {type == 1 ? (
            <Logon logonType={logonType} />
          ) : (
            <Form
              form={form}
              name="login"
              onFinish={handleSubmit}
              autoComplete="off"
              {...formItemLayout}
            >
              <h2>账号注册</h2>
              <Form.Item
                name="phone"
                label="手机号"
                rules={[
                  { required: true, message: "请输入手机号" },
                  {
                    pattern: /^\d{11}$/,
                    message: "请输入11位数字的手机号",
                  },
                ]}
              >
                <Input placeholder="输入手机号" />
              </Form.Item>
              <Form.Item
                name="phoneCode"
                label="验证码"
                rules={[{ required: true, message: "请输入验证码" }]}
              >
                <Space size={10}>
                  <Input placeholder="请输入验证码" />
                  <Button
                    style={{ width: "60px" }}
                    type="primary"
                    onClick={handleGetCode}
                    disabled={sendButtonDisabled}
                    className="yam"
                  >
                    {countdown === 0 ? "获取" : `${countdown}s`}
                  </Button>
                </Space>
              </Form.Item>
              <Form.Item
                name="imageCaptcha"
                label="图形验证码"
                rules={[{ required: true, message: "请输入验证码" }]}
              >
                <div className="captcha-container">
                  <Input
                    placeholder="请输入验证码"
                    maxLength={4}
                    className="captcha-input"
                  />
                  <div className="captcha-image" onClick={generateCaptcha}>
                    <canvas
                      ref={canvasRef}
                      width="180"
                      height="40"
                      style={{ cursor: "pointer" }}
                    />
                  </div>
                </div>
              </Form.Item>
              <Form.Item name="password" label="密码" rules={passwordRules}>
                <Input.Password placeholder="输入登录密码" />
              </Form.Item>
              <Form.Item
                name="confirmPassword"
                label="确认密码"
                rules={[
                  { required: true, message: "请再次输入密码" },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("password") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject("两次输入的密码不一致!");
                    },
                  }),
                ]}
              >
                <Input.Password placeholder="再次输入登录密码" />
              </Form.Item>
              <Form.Item
                name="email"
                label="邮箱"
                rules={[
                  { required: true, message: "请输入邮箱地址" },
                  { type: "email", message: "请输入正确的邮箱地址" },
                ]}
              >
                <Input placeholder="请输入邮箱地址" />
              </Form.Item>
              <Form.Item wrapperCol={{ offset: 6, span: 16 }}>
                <div className="agreement-section">
                  <Checkbox
                    checked={agreeToTerms}
                    onChange={(e) => setAgreeToTerms(e.target.checked)}
                  >
                    我已阅读并同意
                  </Checkbox>
                  <a
                    href="/agreements/terms.html"
                    target="_blank"
                    className="agreement-link"
                  >
                    《用户协议》
                  </a>
                  和
                  <a
                    href="/agreements/privacy.html"
                    target="_blank"
                    className="agreement-link"
                  >
                    《隐私政策》
                  </a>
                </div>
              </Form.Item>
              <Form.Item wrapperCol={{ offset: 6, span: 16 }}>
                <Button type="primary" htmlType="submit" className="login_btn">
                  注册
                </Button>
              </Form.Item>
            </Form>
          )}
          {type == 1 ? (
            <div className="change_login" onClick={changeLogon_type}>
              {logonType == 2 ? "手机号登录" : "账号密码登录"}
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
};

export default Login;
